<template>
  <div class="main">
    <!-- 标签栏 -->
    <div class="label-boxs">
      <div
        :class="['label', { 'label-active': item === active }]"
        v-for="item in list"
        :key="item"
        @click="active = item"
      >
        {{ item }}

        <span v-if="item === active"></span>
      </div>
    </div>
    <!-- 卡片列表 -->
    <div class="card-list" v-if="active === '现金'">
      <div
        class="card-item"
        v-for="(item, index) in list1"
        @click="goUrl(item)"
        :key="index"
      >
        <img :src="item.thumbImageUrl" @error="handleError" />
        <div class="title">{{ item.name }}</div>
        <div class="number-box">
          <span>{{ item.displayPoints }}</span
          >金币
        </div>
      </div>

      <div class="empty-box" v-if="list1.length === 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <div class="card-list" v-if="active === '卡券'">
      <div
        class="card-item"
        v-for="(item, index) in list2"
        @click="goUrl(item)"
        :key="index"
      >
        <img class="coupons-img" :src="item.url" />
        <div class="title">{{ item.title }}</div>
        <div class="number-box">
          <span>{{ item.number }}</span
          >{{ item.unit }}
        </div>
      </div>

      <div class="empty-box" v-if="list2.length === 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <div class="card-list" v-if="active === '实物'">
      <div
        class="card-item"
        v-for="(item, index) in list3"
        @click="goUrl(item)"
        :key="index"
      >
        <img class="img" :src="item.url" />
        <div class="title title-entity">{{ item.title }}</div>
        <div class="number-box">
          <span>{{ item.number }}</span
          >{{ item.unit }}
        </div>
      </div>
      <div class="empty-box" v-if="list3.length === 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <Tabbar :active="3"></Tabbar>
  </div>
</template>

<script>
import Tabbar from "@/components/tabbar.vue";

import {
  getGifts,
  getWeChatAuthWechatUrl,
} from "@/api/mobile";
import { generateUUID } from "@/utils/replace";
export default {
  data() {
    return {
      active: "现金",
      list: ["现金", "卡券", "实物"],
      cashList: [
        {
          url: require("@/assets/mobile/image/exchange/wxhb.png"),
          title: "5元微信红包",
          number: 100,
          unit: "金币",
          type: 1,
        },
        {
          url: require("@/assets/mobile/image/exchange/wxhb.png"),
          title: "10元微信红包",
          number: 200,
          unit: "金币",
          type: 1,
        },
        {
          url: require("@/assets/mobile/image/exchange/wxhb.png"),
          title: "15元微信红包",
          number: 300,
          unit: "金币",
          type: 1,
        },
        {
          url: require("@/assets/mobile/image/exchange/zfbhb.png"),
          title: "5元支付宝现金",
          number: 100,
          unit: "金币",
          type: 2,
        },
        {
          url: require("@/assets/mobile/image/exchange/zfbhb.png"),
          title: "10元支付宝现金",
          number: 200,
          unit: "金币",
          type: 2,
        },
        {
          url: require("@/assets/mobile/image/exchange/zfbhb.png"),
          title: "15元支付宝现金",
          number: 300,
          unit: "金币",
          type: 2,
        },
      ],
      couponsList: [
        {
          url: require("@/assets/mobile/image/exchange/juan.png"),
          title: "5元代金券",
          number: 100,
          unit: "金币",
          type: 3,
        },
        {
          url: require("@/assets/mobile/image/exchange/liwu.png"),
          title: "兑换xx礼品",
          number: 100,
          unit: "金币",
          type: 4,
        },
        {
          url: require("@/assets/mobile/image/exchange/juan.png"),
          title: "10元代金券",
          number: 200,
          unit: "金币",
          type: 3,
        },
        {
          url: require("@/assets/mobile/image/exchange/10.png"),
          title: "10元话费卡",
          number: 200,
          unit: "金币",
          type: 5,
        },
        {
          url: require("@/assets/mobile/image/exchange/30.png"),
          title: "30元话费卡",
          number: 600,
          unit: "金币",
          type: 6,
        },
        {
          url: require("@/assets/mobile/image/exchange/50.png"),
          title: "50元话费卡",
          number: 1000,
          unit: "金币",
          type: 7,
        },
      ],
      entityList: [
        {
          url: require("@/assets/mobile/image/exchange/entity1.png"),
          title: "润本婴儿童电热驱蚊器",
          number: 100,
          unit: "金币",
          type: 8,
        },
        {
          url: require("@/assets/mobile/image/exchange/entity1.png"),
          title: "润本婴儿童电热驱蚊器",
          number: 100,
          unit: "金币",
          type: 8,
        },
        {
          url: require("@/assets/mobile/image/exchange/entity1.png"),
          title: "润本婴儿童电热驱蚊器",
          number: 100,
          unit: "金币",
          type: 8,
        },
        {
          url: require("@/assets/mobile/image/exchange/entity2.png"),
          title: " 欧尼杨茶树精油",
          number: 100,
          unit: "金币",
          type: 9,
        },
        {
          url: require("@/assets/mobile/image/exchange/entity2.png"),
          title: " 欧尼杨茶树精油",
          number: 100,
          unit: "金币",
          type: 9,
        },
        {
          url: require("@/assets/mobile/image/exchange/entity2.png"),
          title: " 欧尼杨茶树精油",
          number: 100,
          unit: "金币",
          type: 9,
        },
      ],
      list1: [],
      list2: [],
      list3: [],
      weixinFlag: false,
    };
  },
  components: { Tabbar },
  methods: {
    goUrl(data) {
      this.$router.push(`/mobile/prizeDetails?id=${data.id}`);
    },
    handleError(e) {
      console.log("触发");
      e.target.src = process.env.VUE_APP_SERVER + "/images/gift/default.png";
      e.target.onerror = null; // 防止闪图/死循环
    },
    async getGifts(type) {
      if (type) {
        this.page = type;
      }
      await getGifts({
        page: this.page,
        size: this.size,
      }).then((res) => {
        if (res.code === 200) {
          this.list1 = res.data.list;
          this.total = res.data.dataCount;
          this.list1.forEach((_, index, array) => {
            array[index].show = false;
          });
        }
      });
    },
  },
  async created() {
    if (this.$route.query.from && this.$route.query.from === "wechat") {
      this.weixinFlag = true;
      let state = generateUUID();
      let redirectUrl =
        "https://www.aidajuan.com/mobile/landingPage?url=" + "/mobile/exchange";
      await getWeChatAuthWechatUrl({
        redirectUrl,
        state,
      }).then((res) => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      });
    }
    if (this.weixinFlag) {
      return;
    }

    await this.getGifts();
  },
};
</script>

<style lang="scss" scoped>
.main {
  background-color: #f8f8f8;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
  position: relative;
  //标签栏
  .label-boxs {
    display: flex;
    align-items: center;
    background-color: #f8f8f8;
    top: 0;
    height: 50px;
    padding: 0 15px;
    position: fixed;
    z-index: 999;
    width: 100%;
    .label {
      margin-right: 23px;
      flex-shrink: 0;
      font-size: 16px;
      color: #232323;
      font-weight: bolder;
      position: relative;
      span {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        width: 19px;
        height: 4px;
        background: #8846ff;
        border-radius: 10px 10px 10px 10px;
        bottom: -8px;
      }
    }
    .label-active {
      font-size: 22px;
      color: #8846ff;
    }
  }
  //卡片列表
  .card-list {
    padding: 0 15px;
    padding-top: 60px;
    display: flex;
    flex-wrap: wrap;
    .card-item {
      width: calc((100% - 16px) / 3);
      margin-right: 8px;
      height: 158px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      margin-bottom: 10px;
      box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.05);
      img {
        width: 54px;
        height: 54px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 18px;
      }
      .img {
        width: 97px;
        height: 92px;
        margin-top: 6px;
      }
      .title {
        font-size: 14px;
        color: #232323;
        text-align: center;
        margin-top: 22px;
        overflow: hidden; /* 隐藏超出部分的内容 */
        white-space: nowrap; /* 禁止文本换行 */
        text-overflow: ellipsis; /* 在文本末尾添加省略号 */
        padding: 0 5px;
      }
      .title-entity {
        margin-top: 8px;
      }
      .number-box {
        font-size: 12px;
        color: #ff3636;
        text-align: center;
        margin-top: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 18px;
          font-weight: bolder;
          margin-right: 6px;
        }
      }
    }
    .card-item:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.empty-box {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>